// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadInstrumentAction } from '../../actions/instrument';

export type State = {
  +[key: string]: {|
    +loading: boolean,
    +loaded: boolean,
    +entities: string,
  |},
  loading: boolean,
};

const initialState = {
  loading: false,
};

export default function instruments(
  state: State = initialState,
  action: LoadInstrumentAction
): State {
  if (action.type === 'FETCH_INSTRUMENT' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
